
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { Customer } from '../../global/models'

@Component
export default class CustomerReadPage extends Vue {
  customer: Customer | null = null

  error: string | null = null

  get customerId() {
    return this.$route.params.id
  }

  mounted() {
    this.getData()
  }

  async getData() {
    try {
      const response = await axios.get<Customer>(`/customers/${this.customerId}`)
      this.customer = response.data
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 404:
            this.error = 'not-found'
            break
          case 403:
            this.error = 'unauthorised'
            break
          default:
            this.error = 'generic'
        }
      } else {
        this.error = 'generic'
      }
    }
  }
}
